import { useEffect, useState } from "react";

import useLocalization from "../../hooks/useLocalization";

import AutoComplete from "../elements/AutoComplete";

const ProvinceSelect = ({ value, onChange }) => {
  const { provinceList } = useLocalization();

  const [options, setOptions] = useState(null);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    const options = [];

    for (const province of provinceList()) {
      options.push({
        key: province.id,
        id: province.id,
        name: province.name,
      });
    }

    setOptions(options);
  };

  const handleChange = (newValue) => {
    onChange(newValue);
  };

  if (!options) return null;

  return (
    <AutoComplete
      id={"provinces"}
      label={"provinces"}
      value={value || ""}
      onChange={(newValue) => handleChange(newValue)}
      items={options}
    />
  );
};

export default ProvinceSelect;
